import {ApiClientService, EntityApiService} from '@dofleini/security';

import {authentication} from '@/settings';

class CompanyApiService extends EntityApiService {

  searchMap = (params, config) => {
    return ApiClientService.post(this.getPath('/searchMap', params), params, config);
  }

  query = (params, config) => {
    return ApiClientService.post(this.getPath('', params), params, config);
  }

  count = (params) => {
    return ApiClientService.post(this.getPath('/count'), params);
  }

  updateRepresentative = async ({id, idNumber, partners}, config) => {
    const params = partners?.map((e) => ({...e, representative: e?.idNumber === idNumber}));
    return ApiClientService.patch(this.getPath(`/${id}`, {partners: params}), {partners: params}, config);
  }

  updateStatus = async (params, config) => {
    return ApiClientService.post(this.getPath('/status'), params, config);
  }

  existIdentifier = (params) => {
    return ApiClientService.post(this.getPath('/exist-identifier'), params);
  }

  isRepresentativeOn = (idNumber, params) => {
    return ApiClientService.get(this.getPath(`/is-representative/${idNumber}`), params);
  }

  invitePartners = (params) => {
    return ApiClientService.post(this.getPath('/invite-partners'), params);
  }

  recuperate = (id) => {
    return ApiClientService.post(this.getPath(`/${id}/recuperate`));
  }
  
  getDocuments = (id) => {
    return ApiClientService.patch(this.getPath(`/${id}/get-documents`));
  }
  
  reactivateActivities = (id, params) => {
    if (typeof id === 'object') {
      params = id;
      id = id._id;
    }
    return ApiClientService.patch(this.getPath(`/${id}/reactivate-activities`, params), params);
  }
  
  exportExcel = async (params) => {
    return ApiClientService.post(this.getPath('/export?format=excel'), params);
  }
  
  searchTCP = async (params) => {
    return ApiClientService.post(this.getPath('/search-tcp'), params);
  }
}

export default new CompanyApiService(`${authentication.path}/api/companies`);
